module.exports = __webpack_public_path__ + "static/neotech-webfont-ef722236f0b8b7d437874ade303e622c.woff";